import React from 'react';

const PageTitlePortfolioInside = () => {
    return (
        <section id="page-title" className="block">
            <div className="wrapper">
                <div className="page-title-content">
                    <div className="page-title-img">
                        <img src="assets/img/demo/03_img.png" alt="Happy Anniversary" />
                    </div>

                    <div className="page-title-description">
                        <div className="title">
                            <h1 className="large">Wedding <br/>Photography.</h1>
                        </div>

                        <div className="description">
                            <p>Grace & Tommy</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PageTitlePortfolioInside;